import { useFeatureFlags } from '@contexts/featureFlags'
import { isUnavailablePlan } from '@pages/Checkout/helpers/isUnavailablePlan'
import { selectPlanAndGoToStep } from '@pages/Checkout/helpers/selectPlanAndGoToStep'
import { useCheckoutContext } from '@pages/Checkout/routes/contexts'
import { Alert, Button, Spacer } from '@ui-kit'
import { Fragment } from 'react'
import { Trans, useTranslation } from 'react-i18next'

export const UnavailablePlansAlert = () => {
  const { t } = useTranslation()

  const {
    accountPlanName,
    accountPlanRecordKey,
    goToStep,
    setCheckoutDataInContext
  } = useCheckoutContext()

  const hasAccessToFreePlanRestriction = useFeatureFlags(
    'FREE_PLAN_RESTRICTIONS'
  )

  const showAlert =
    isUnavailablePlan(accountPlanRecordKey) && !hasAccessToFreePlanRestriction

  const handleSelectPlanAndGoToStep = () => {
    selectPlanAndGoToStep({
      recordKey: accountPlanRecordKey,
      goToStep
    })

    setCheckoutDataInContext(prev => ({
      ...prev,
      chosenRecordKey: accountPlanRecordKey
    }))
  }

  return showAlert ? (
    <Fragment>
      <Alert
        variant='info'
        additionalContent={
          <Button size={12} onClick={handleSelectPlanAndGoToStep}>
            {t('change.plan.page.stay.with.this.plan')}
          </Button>
        }
      >
        <Trans
          i18nKey='checkout.plans.plan.alert.unavailable.plan'
          values={{
            plan: accountPlanName
          }}
        />
      </Alert>

      <Spacer space={40} />
    </Fragment>
  ) : null
}

UnavailablePlansAlert.displayName = 'CheckoutPlansAlertsUnavailablePlansAlert'
